import { Phone, Mail, MapPin } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { T } from "../hooks/useSiteTexts";
import { Reveal, Chapter } from "../components/Reveal";
import { QuoteForm } from "../components/QuoteForm";
import { IMAGES, CONTACT } from "../data/content";

export default function Contactos() {
    return (
        <>
            <PageHero
                overline="Contactos"
                title="Tem um projeto para"
                accent="transportar?"
                subtitle={<T k="contactos-hero-sub" fallback="Fale connosco e encontre a solução certa para a sua operação. Resposta rápida, sem compromisso." />}
                image={IMAGES.aerialHighway}
                slot="contactos-hero"
            />

            <section className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32" data-testid="contact-section">
                <div className="grid gap-16 lg:grid-cols-12">
                    <div className="lg:col-span-4">
                        <Reveal>
                            <Chapter num={1} label="Contactos" />
                            <h2 className="mt-8 font-display text-3xl font-black uppercase tracking-tight sm:text-4xl">
                                Transportes Alzira,{" "}
                                <span className="text-brand">Lda.</span>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <ul className="mt-10 space-y-8">
                                <li className="flex items-start gap-4">
                                    <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-white/15">
                                        <MapPin className="h-5 w-5 text-brand" />
                                    </span>
                                    <div>
                                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                                            Morada
                                        </p>
                                        <p className="mt-2 text-sm text-zinc-300" data-testid="contact-address">
                                            {CONTACT.address}
                                            <br />
                                            {CONTACT.locality}
                                        </p>
                                    </div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-white/15">
                                        <Phone className="h-5 w-5 text-brand" />
                                    </span>
                                    <div>
                                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                                            Telefone
                                        </p>
                                        <a
                                            href={CONTACT.phoneHref}
                                            data-testid="contact-phone"
                                            className="mt-2 block text-sm text-zinc-300 transition-colors duration-300 hover:text-brand"
                                        >
                                            {CONTACT.phone}
                                        </a>
                                    </div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-white/15">
                                        <Mail className="h-5 w-5 text-brand" />
                                    </span>
                                    <div>
                                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                                            Email
                                        </p>
                                        <a
                                            href={`mailto:${CONTACT.email}`}
                                            data-testid="contact-email"
                                            className="mt-2 block text-sm text-zinc-300 transition-colors duration-300 hover:text-brand"
                                        >
                                            {CONTACT.email}
                                        </a>
                                    </div>
                                </li>
                            </ul>
                            <div className="mt-12 border border-white/10 bg-coal p-6">
                                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                                    Área de atuação
                                </p>
                                <p className="mt-3 font-display text-2xl font-black uppercase">
                                    Portugal <span className="text-brand">&</span> Espanha
                                </p>
                            </div>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-8">
                        <Reveal delay={0.15}>
                            <div className="border border-white/10 bg-coal p-8 lg:p-12">
                                <h2 className="font-display text-2xl font-black uppercase tracking-tight sm:text-3xl">
                                    Pedido de <span className="text-brand">orçamento</span>
                                </h2>
                                <p className="mt-3 text-sm text-zinc-400">
                                    Preencha o formulário e entraremos em
                                    contacto consigo com a maior brevidade
                                    possível.
                                </p>
                                <div className="mt-10">
                                    <QuoteForm />
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section className="border-t border-white/10" data-testid="contact-map">
                <iframe
                    title="Localização Transportes Alzira — Sertã, Portugal"
                    src="https://maps.google.com/maps?q=Rua%20Senhora%20dos%20Rem%C3%A9dios%2C%20Sert%C3%A3%2C%20Portugal&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    className="h-[420px] w-full grayscale invert-[0.9] contrast-[0.9]"
                    loading="lazy"
                    data-testid="contact-map-iframe"
                />
            </section>
        </>
    );
}
